import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore/lite'
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from 'firebase/auth'

const CountryCode = Object.freeze({
  vi: '+84',
})
const ErrorCode = Object.freeze({
  PhoneNumberInvalid: 'auth/invalid-phone-number',
})

class Firebase {
  _config = null;
  app = null;
  db = null;
  auth = null;
  recaptchaVerifier = null;
  MESSAGE_LANGUAGE_CODE_DEFAULT = 'vi';
  ErrorCode = ErrorCode;

  /**
   * @description khởi tạo các thành phần firebase
   * @author PVThang 13.02.2023
   */
  init = function () {
    // Your web app's Firebase configuration
    const me = this

    if (me.app) {
      return
    }
    try {
      // Your web app's Firebase configuration
      // For Firebase JS SDK v7.20.0 and later, measurementId is optional
      me._config = {
        apiKey: 'AIzaSyB75QW9a3rXBc9Os67iNSx1V9w_1uovCH0',
        authDomain: 'qlth-sisap.firebaseapp.com',
        databaseURL: 'https://qlth-sisap.firebaseio.com',
        projectId: 'qlth-sisap',
        storageBucket: 'qlth-sisap.appspot.com',
        messagingSenderId: '283693565694',
        appId: '1:283693565694:web:8a3701c62fb304aa7e87af',
        measurementId: 'G-W44RDQK9V9',
        ...window._firebaseConfig,
      }

      me.app = initializeApp(me._config)
      me.db = getFirestore(me.app)
      me.auth = getAuth()
      me.auth.languageCode =
        window._firebaseConfig?.languageCode ||
        me.MESSAGE_LANGUAGE_CODE_DEFAULT
    } catch (e) {
      console.log(e)
    }
  };

  /**
   * @description tạo recaptcha verifier
   * @param {*} elementId
   * @returns
   * @author PVThang 13.02.2023
   */
  createRecaptchaVerifier (elementId, callback) {
    const me = this

    if (!me.auth || !elementId) {
      return
    }

    callback ??= () => {}

    me.recaptchaVerifier = new RecaptchaVerifier(
      elementId,
      {
        size: 'invisible',
        callback: callback,
      },
      me.auth
    )
  }

  /**
   * @description Gửi mã otp
   * @author PVThang 13.02.2023
   */
  async sendOTP (phone) {
    const me = this

    // eslint-disable-next-line no-useless-catch
    try {
      me.confirmationResult = await signInWithPhoneNumber(
        me.auth,
        phone,
        me.recaptchaVerifier
      )
      return me.confirmationResult
    } catch (error) {
      // error.code
      // auth/invalid-phone-number - Số điện thoại không hợp lệ
      throw error
    }
  }

  /**
   * @description Xác thực OTP
   * @author PVThang 13.02.2023
   */
  async verifyOTP (otp) {
    const me = this

    // eslint-disable-next-line no-useless-catch
    try {
      const result = await me.confirmationResult?.confirm(otp)
      me.confirmationResult = null
      return result
    } catch (error) {
      // error.code
      // auth/code-expired - otp hết hạn
      // auth/invalid-verification-code - otp không chính xác
      throw error
    }
  }

  /**
   * @description Chuyển local phone number sang international phone number
   * @author PVThang
   * @param {*} phone
   * @param {*} country
   * @returns
   */
  formatInternationalPhoneNumber (phone, country = 'vi') {
    const countryCode = CountryCode[country]
    if (!phone || phone.startsWith(countryCode)) {
      return phone
    }

    return `${countryCode}${phone.slice(1, phone.length)}`
  }
}

const firebaseInstance = new Firebase()

export default firebaseInstance
